import React from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Container from 'components/Container';

const mock = [
  {
  field: 'Medical Course',
  },
  {
    name: 'ANANYA JAYARAMAN',
    email: 'MBBS',
    title: 'MVJ MEDICAL COLLEGE,BANGALORE ',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'ISHIKA JAIN',
    email: 'MBBS',
    title: 'RAMAIAH MEDICAL COLLEGE,BANGALORE  ',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'K VINEETH KRISHNA ',
    email: 'MBBS ',
    title: 'PSG INSTITUTE OF MEDICAL SCIENCES AND RESEARCH COIMBATORE,COIMBATORE   ',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'KARAN',
    email: 'MBBS ',
    title: 'AIMS,BANGALORE   ',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'S KEERTHANA',
    email: 'MBBS ',
    title: 'RAMAIAH MEDICAL COLLEGE,BANGALORE   ',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'VARSHA RAJU ',
    email: 'MBBS ',
    title: 'VYDEHI INSTITUTE OF MEDICAL SCIENCE AND RESEARCH CENTRE ,BANGALORE   ',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'ANANYA P ',
    email: 'MBBS ',
    title: 'RAMAIAH MEDICAL COLLEGE,BANGALORE    ',      
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: ' NIDHI V ',
    email: 'MBBS',
    title: 'BGS GIMS,BANGALORE    ',       
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: ' MALVIKA SURESH MALLANDIRA  ',
    email: 'MBBS ',
    title: 'GGS,BANGALORE    ',      
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: ' SATHVIK R L  ',
    email: 'MBBS ',
    title: 'JJMC,DAVANGERE    ',      
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    field: 'Other Professional Courses',
  },
  {
    name: 'DYUTI DUTTA',
    email: 'INTEGRATED MSC. IN CHEMISTRY ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY, VELLORE',
   
  },
  {
    name: 'KRITTIKA NARAYANAN',
    email: 'PSYCHOLOGY HONS WITH BIO  ',
    title: 'CHRIST UNIVERSITY ,BANGALORE ',
    
  },
  {
    name: 'NAINA PODDAR',
    email: 'B.ARCH',
    title: 'JINDAL SCHOOL OF ART AND ARCHITECTURE,SONIPAT',
    
  },
  {
    name: 'POOJA PRAMOD PULLARKAT',
    email: 'BSC BIOLOGY',
    title: 'AZIM PREMJI UNIVERSITY,BANGALORE',
  
  },
  {
    name: 'MANYA LOHAN',
    email: 'BSC ECONOMICS ',
    title: 'KREA UNIVERSITY ,SRI CITY',
  
  },
  {
    name: 'MEDHAVI SHARAFF',
    email: 'BSC PHYSICS ',
    title: 'AZIM PREMJI UNIVERSITY ,BANGALORE ',
  
  },
  {
    name: 'SHAKAMBARI SANTHOSH',
    email: 'BACHELOR OF CULINARY ARTS',
    title: 'WELCOMGROUP GRADUATE SCHOOL OF HOTEL ADMINISTRATION,MANIPAL',
  
  },
  {
    name: 'ARUSHI GUPTA',
    email: 'BCOM HONOURS',
    title: 'CHRIST UNIVETRSITY,BENGALURU ',
  
  },
  {
    name: 'BATHALA AMRUTHA VARSHINI',
    email: 'BACHELORS IN DESIGN ',
    title: 'SRISHTI MANIPAL INSTITUTE OF ART , DESIGN AND TECHNOLOGY,BANGALORE',
  
  },
  {
    name: 'BENJAMIN THOMAS ROY',
    email: 'BBA.LLB',
    title: 'PES UNIVERSITY,BANGALORE',
  
  },
  {
    name: 'DEV ASHISH PICHIKA',
    email: 'BBA',
    title: 'RV UNIVERSITY ,BANGALORE ',
  
  },
  {
    name: 'KIRTHANA BALAJI',
    email: 'COMMERCE ',
    title: 'ST  JOSEPH,BANGALORE',
  
  },
  {
    name: 'LIPIKA A M',
    email: 'B COM ',
    title: 'RV UNIVERSITY ,BANGALORE',
  
  },
  {
    name: 'SANCHIT SURESH CAVALE',
    email: 'BA LLB',
    title: 'JINDAL GLOBAL SCHOOL ,NEW DEHLI',
  
  },
  {
    name: 'SANJITH P',
    email: 'B COM ',
    title: 'CHRIST UNIVERSITY ,BANGALORE',
  
  },
  {
    name: 'SHAMITHA SRINIVAS',
    email: 'BBA LLB (HONS)',
    title: 'REVA UNIVERSITY ,BENGALURU ',
  
  },
  {
    field: 'Engineering Courses',
  },
  {
    name: 'J HARIHARAN',
    email: 'B-TECH CSE ',
    title: 'NATIONAL INSTITUTE OF TECHNOLOGY, SURATKHAL,SURATKHAL',
  
  },
  {
    name: 'MARC STANLEY ',
    email: ' COMPUTER SCIENCE AND ENGINEERING',
    title: 'BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE, PILANI',
  
  },
  {
    name: 'NITISH KUMAR YARLAGADDA',
    email: 'COMPUTER SCIENCE ',
    title: 'UNIVERSITY OF MINNESOTA - TWIN CITIES ,MINNEAPOLIS ',
  
  },
  {
    name: 'ARCHANA R',
    email: ' BANGALORE ',
    title: 'PES UNIVERSITY ,BANGALORE ',
  
  },
  {
    name: 'KAUSHIK R HARAN',
    email: 'ELECTRICAL AND ELECTRONICS ENGINEERING ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY ,VELLORE',
  
  },
  {
    name: 'KISHORE S SHETTY',
    email: 'CSE(CYBER SECURITY)',
    title: "PESU,BENGALURU ",
  
  },
  {
    name: 'LAKSHMIKANTH B G',
    email: 'COMPUTER SCIENCE ENGINEERING ',
    title: 'M S RAMAIAH INSTITUTE OF TECHNOLOGY,BENGALURU ',
  
  },
  {
    name: 'NAMRATHA SRIDHAR ',
    email: 'BE BIOTECHNOLOGY ',
    title: 'UNIVERSITY OF VISVESVARAYA COLLEGE OF ENGINEERING,BANGALORE ',
  
  },
  {
    name: 'PRADYOTH KASHYAP SALIGRAMA',
    email: 'BIOTECHNOLOGY ENGINEERING ',
    title: 'RAMIAH INSTITUTE OF TECHNOLOGY ,BANGLORE ',
  
  },
  {
    name: 'PRATYUSH VASUDHA NARESH',
    email: 'ELECTRICAL AND ELECTRONICS ENGINEERING ',
    title: 'RAMAIAH INSTITUTE OF TECHNOLOGY,BENGALURU',
  
  },

  {
    name: 'R M HAVISH KUMAR ',            
    email: 'ELECTRONICS AND COMMUNICATIONS ',                            
    title: 'PESU , RR CAMPUS ,BANGALORE ',                            
  
  },
  {
    name: ' S P PRANAV SHARAN',
    email: 'B.TECH (COMPUTER SCIENCE)',
    title: 'M S RAHMIAH INSTITUTE OF TECHNOLOGY ,BANGALORE',
  
  },
  {
    name: 'SANJAN DILEEP',
    email: 'B.TECH IN BIOTECHNOLOGY',
    title: 'RV UNIVERSITY ,BANGALORE',
  
  },
  {
    name: 'SHREYAS SRINIVASAN ',
    email: 'MEDICAL ELECTRONICS ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY,VELLORE',
  
  },
  {
    name: 'VARSHA SURESHBABU',
    email: 'COMPUTER SCIENCE ENGINEERING',
    title: 'MS RAMAIAH INSTITUTE OF TECHNOLOGY ,BENGALURU ',
  
  },
  {
    name: 'ADITYA J KRISHNAN',
    email: 'ELECTRONICS AND COMMUNICATION ENGINEERING ',
    title: 'MSRIT,BANGALORE',
  
  },
  {
    name: 'AISHWARYA S. KAILAS',
    email: 'MECHATRONICS',
    title: 'PES BANASHANKARI,BENGALURE',
  
  },
  {
    name: '  ANIRUDH NAGARAJ',
    email: 'ELECTRONICS AND COMMUNICATION ENGINEERING ',
    title: 'REVA UNIVERSITY ,BANGALORE',
  
  },
  {
    name: 'ARJUN SAILANATHAN',
    email: 'MECHATRONICS ',
    title: 'AMRITA VISHWAVIDYAPEETAM,BANGALORE',
  
  },
  {
    name: 'ASHWIN ARUN IRDE ',
    email: 'B.TECH - ECE ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY ,MANIPAL',
  
  },
  {
    name: 'BHAVANI SHRI S',
    email: 'MATHEMATICS AND COMPUTING',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY ,CHENNAI',
  
  },
  {
    name: 'BHOOOMICKA D G',
    email: 'INFORMATION TECHNOLOGY',
    title: 'M.S RAMAIAH,BANGALORE',
  
  },
  {
    name: 'KARTIK NAIR',
    email: 'COMPUTER SCIENCE BTECH (HONOURS)',
    title: 'RAMAIAH UNIVERSITY OF APPLIED SCIENCES ,BENGALURE',
  
  },
  {
    name: 'LOHITH R GOWDA',
    email: 'CSC CORE',
    title: 'RV UNIVERSITY ,BANGALORE',
  
  },
  {
    name: 'M.CHARAN AKASH ',
    email: 'DUAL DEGREE MSC PHYSICS + BE',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY,VELLORE ',
  
  },
  {
    name: 'PRITHVI S K',
    email: 'COMPUTER SCIENCE DATA SCIENCE ',
    title: 'PES UNIVERSITY,BENGALURE',
  
  },
  {
    name: 'RASHMIKA SURESH KUMAR ',
    email: 'INFORMATION SCIENCE AND ENGINEERING ',
    title: 'CMRIT BANGALORE ,BANGALORE',
  
  },
  {
    name: 'RAYHAAN A R',
    email: 'COMPUTER SCIENCE AND ENGINEERING',
    title: 'BMSIT,BANGALORE',
  
  },
  {
    name: 'RIYA CHANDRAKANT SAPKALE',
    email: 'COMPUTER SCIENCE AND ENGINEERING',
    title: 'PES RR NAGAR,BENGALURE',
  
  },
  {
    name: 'SHARANYA SANDEEP ',
    email: 'B.TECH. INFORMATION TECHNOLOGY',
    title: 'M S RAMAIAH INSTITUTE OF TECHNOLOGY ,BANGALORE',
  
  },
  {
    name: 'SHREYAS KARTHIGEYAN',
    email: 'COMPUTER SCIENCE AND ENGG',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY, VELLORE BRANCH,VELLORE',
  
  },
  {
    name: 'SHREYASH MANDI',
    email: 'BTECH - COMPUTER SCIENCE AND ENGINEERING ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY, BANGALORE ',
  
  },
  {
    name: 'SNIGDHA SV ',
    email: 'BTECH CSE [HONS]',
    title: 'PESU - RR CAMPUS,BANGALORE',
  
  },
  {
    name: 'SWARAJ SINGH',
    email: 'COMPUTER SCIENCE',
    title: 'RV UNIVERSITY ,BANGALORE',
  
  },
  {
    name: 'ANANYA K P',
    email: 'COMPUTER SCIENCE',
    title: 'RV COLLEGE ,BANGALORE',
  
  },
  {
    name: 'KRISHAN KAUSHAL',
    email: 'COMPUTER SCIENCE ENGINEERING',
    title: 'KIIT,BHUVANESHWAR',
  
  },
  {
    name: 'ROHAN',
    email: 'ELECTRICAL AND ELECTRONICS ENGINEERING ',
    title: 'BMSIT,BANGALORE',
  
  },
  {
    name: 'VAIBHAV SINGH',
    email: 'BE(IT)',
    title: 'MANIPAL INSTITUTE,BANGALORE',
  
  },
  {
    name: 'BHARAT A NAIR',
    email: 'B ARCH',
    title: 'RAMIAH INSTITUTE OF TECHNOLOGY ,BANGALORE',
  
  },
  {
    name: 'ROHIT RAGHAVENDRACHARYA MATHAD',
    email: 'ELECTRONICS AND COMMUNICATION ENGINEERING ',
    title: 'NITTE MEENAKSHI,BANGALORE',
  
  },
 
];

const Simple = () => {
  const theme = useTheme();
  return (
   
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 200 }} aria-label="simple table">
         
          <TableBody>
            {mock.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                <Typography
                  align='left'
                  variant={'h6'}
                  fontWeight={600}
                  color={'blue'}
                >
                  {item.field}
                </Typography>
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.email}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.title}
                  </Typography>
                </TableCell>
               
           
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

  );
};

export default Simple;